 
import { createSlice } from '@reduxjs/toolkit';
import {
  QCTaskSeriesState,
  QCTaskSeriesFetchAction,
  QCTaskSeriesFetchSuccessAction,
  SetAssignedLabelsByVisitAction,
  SetFlatVisitsAction,
  SetFlatSeriesAction,
} from './QCTaskSeries.types';
import { createSelector, createSliceHook, makeActionCreator } from '../helpers';

const name = 'QCTaskSeries';

const initialState: QCTaskSeriesState = {
  loading: false,
  data: null,
  flatVisits: {},
  flatSeries: {},
  assignedLabelsByVisit: {},
  error: undefined,
};

const { actReq, actReject, actResolve } =
  makeActionCreator<QCTaskSeriesState>();

export const QCTaskSeriesSlice = createSlice({
  name: 'QCTaskSeries',
  initialState,
  reducers: {
    fetchQCTaskSeries: actReq<QCTaskSeriesFetchAction['payload']>(),
    fetchQCTaskSeriesSuccess:
      actResolve<QCTaskSeriesFetchSuccessAction['payload']>('data'),
    fetchQCTaskSeriesFailure: actReject(),
    setAssignedLabelsByVisit: actResolve<
      SetAssignedLabelsByVisitAction['payload']
    >('assignedLabelsByVisit', null, null),
    setFlatVisits: actResolve<SetFlatVisitsAction['payload']>(
      'flatVisits',
      null,
      null
    ),
    setFlatSeries: actResolve<SetFlatSeriesAction['payload']>(
      'flatSeries',
      null,
      null
    ),

    clear: state => {
      state.data = null;
    },
  },
});

export const {
  fetchQCTaskSeries,
  fetchQCTaskSeriesSuccess,
  fetchQCTaskSeriesFailure,
  setAssignedLabelsByVisit,
  setFlatVisits,
  setFlatSeries,
  clear,
} = QCTaskSeriesSlice.actions;

export const actions = {
  ...QCTaskSeriesSlice.actions,
};

export const selectQCTaskSeriesState = createSelector('QCTaskSeries');
export const useQCTaskSeriesSlice = createSliceHook(name, actions);
